import { useLink } from "@refinedev/core";
import { Logo } from "./styled";

type TitleProps = {
    collapsed: boolean;
};

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
    const Link = useLink();

    return (
        <Logo>
            <Link to="/">
                <img
                    src="/images/logo.png"
                    alt="Split Fácil"
                        style={{
                        height: collapsed ? "2rem" : "2.5rem",
                        width: "auto",
                        maxWidth: collapsed ? "80px" : "160px",
                        objectFit: "contain",
                        }}
                    />
            </Link>
        </Logo>
    );
};
